export const spanish = {
  feedback: {
    "title": "Enviar comentarios",
    "category": "Categoría",
    "suggestion": "Sugerencia",
    "problem": "Problema",
    "other": "Otro",
    "message": "Tus comentarios",
    "placeholder": "¿Qué mejorarías o qué no funcionó?",
    "email": "Email para responder (opcional)",
    "send": "Enviar comentarios",
    "sending": "Enviando…",
    "success": "Gracias — hemos recibido tus comentarios.",
    "error": "No se pudieron enviar. Tu texto sigue aquí; inténtalo de nuevo.",
    "invalid": "Introduce entre 10 y 3.000 caracteres y un email válido si lo indicas.",
    "signIn": "Inicia sesión para enviar comentarios",
    "inbox": "Comentarios de usuarios",
    "empty": "Aún no hay comentarios.",
    "reviewed": "Revisado",
    "markReviewed": "Marcar como revisado",
    "refresh": "Actualizar",
    "new": "Nuevo"
},
  menu: {
    signOut: "Cerrar Sesión",
    signIn: "Iniciar Sesión / Registrarse",
    talkToUs: "Habla con nosotros",
    language: "Idioma",
    deleteAccount: "Eliminar Cuenta",
    accountSettings: "Configuración de cuenta",
  },
  theme: {
    light: "Claro",
    dark: "Oscuro",
  },
  landing: {
    heroKicker: "Para ciudadanos y municipios de todo el mundo",
    heroSub: "Llevamos tu voz al municipio — en cualquier parte del mundo.",
    municipalityLogin: "Acceso ayuntamientos",
    pecCardTitle: "Cada informe llega a municipios de todo el mundo",
    pecBadge: "Email",
    pecCardBody: "Desde cualquier ciudad, en cualquier país. Los municipios asociados reciben los informes directamente; donde el municipio aún no está asociado, enviamos cada informe a las autoridades locales por correo electrónico, para que ningún problema pase desapercibido.",
    pecTitle: "Cada informe cuenta, incluso sin acuerdo",
    pecBody: "Si tu municipio aún no es socio de ShapeIt, enviamos cada informe a las autoridades locales por correo electrónico, para que ningún problema pase desapercibido.",
    pecHighlight: "Enviamos los informes a los municipios por correo electrónico",
    ctaSub: "Únete a ciudadanos y municipios de todo el mundo para marcar la diferencia, un informe a la vez.",
  },
  mapHeader: {
    appName: "Shapeit",
    login: "Iniciar Sesión / Registrarse",
    searchPlaceholder: "Busca lugares o haz clic en cualquier punto del mapa para reportar un problema",
    clearSearch: "Borrar búsqueda",
  },
  mapLegend: {
    title: "Leyenda Shapeit",
    buttonLabel: "Leyenda",
    dirty: "Sucio",
    unsafe: "Inseguro",
    needsFix: "Necesita Arreglo",
  },
  dialog: {
    selectLanguage: "Selecciona tu idioma preferido",
    chooseLanguage: "Elige un idioma para la interfaz de la aplicación.",
    confirm: "Confirmar",
    welcome: {
      title: "¡Bienvenido!",
      message: "Shapeit está aquí para empoderarte, queremos que puedas moldear tu ciudad y transformarla en un lugar mejor. Cada vez que detectes un problema, puedes informarlo y también puedes dar me gusta a los informes de otros usuarios para darles mayor visibilidad. Por nuestra parte, nos aseguraremos de mantener a las autoridades de la ciudad actualizadas sobre los problemas más urgentes.",
      message2: "Shapeit está trabajando para asociarse con municipalidades de todo el mundo. Aunque tu ciudad aún no sea socia, enviamos cada informe a las autoridades locales por correo electrónico, para que ningún problema pase desapercibido. Cada informe ayuda a construir una base de datos actualizada de problemas urbanos en tu área: cuantos más recopilemos, más fuerte será nuestra voz cuando nos acerquemos a las autoridades locales. ¡Ahora ve y haz de tu ciudad un lugar mejor!",
      next: "Siguiente",
      button: "¡Comencemos!"
    }
  },
  reports: {
    overview: "Resumen de Informes",
    trending: "Tendencia",
    myReports: "Mis Informes",
    yourReports: "Tus Informes",
    recentReports: "Informes Recientes",
    by: "por",
    anonymous: "Anónimo",
  },
  usernameSetup: {
    title: "Elige tu nombre de usuario",
    description: "Elige un nombre público que se mostrará en tus reportes. Puedes cambiarlo en los ajustes de la cuenta.",
    placeholder: "Tu nombre de usuario",
    save: "Guardar",
    saving: "Guardando...",
    skip: "Más tarde",
    tooShort: "El nombre de usuario debe tener al menos 2 caracteres",
    noEmail: "El nombre de usuario no puede contener @",
    success: "Nombre de usuario guardado",
    error: "No se pudo guardar el nombre de usuario",
  },
  reportForm: {
    postAnonymously: "Publicar de forma anónima",
    postAnonymouslyHint: "Tu nombre no se mostrará en este reporte.",
    postingAs: "Publicando como",
    title: "Enviar un Informe",
    description: "Descripción",
    uploadPhoto: "Subir Foto",
    takePhoto: "Tomar Foto",
    changePhoto: "Cambiar Foto",
    preview: "Vista previa",
    submit: "Enviar Informe",
    submitting: "Enviando...",
    loginRequired: "Debes iniciar sesión para enviar un informe",
    uploadFailed: "Error al cargar el informe",
    photoUploadFailed: "No se pudo enviar la foto. Tu informe sigue aquí.",
    sendWithoutPhoto: "Enviar sin foto",
    selectIssue: "Por favor selecciona un tipo de problema",
    selectIssueType: "Selecciona un tipo de problema",
    moderationWarning: "Los informes se moderan automáticamente. Contenido ofensivo, spam o inapropiado será rechazado.",
    rejectedContent: "Tu informe contiene contenido inapropiado y no puede ser publicado",
    rateLimitExceeded: "Has alcanzado el límite de 5 informes por hora. Inténtalo más tarde.",
    characterLimit: "La descripción no puede superar los 500 caracteres",
    appealLink: "Enviar apelación por correo",
    offensiveContent: "Tu mensaje contiene lenguaje inapropiado",
    validatingImage: "Validando imagen...",
        aiAnalyzing: "La IA está analizando...",
    duplicateWarning: "Ya existe un reporte similar cerca. Considera votarlo en lugar de crear un duplicado.",
    aiSuggestions: "Sugerencias de IA",
    suggestedTitle: "Título sugerido:",
    priority: "Prioridad:",
    inappropriateImage: "La imagen contiene contenido inapropiado y no puede ser utilizada",
    notRelevantImage: "La foto no parece mostrar un problema urbano. Sube una foto del problema que quieres reportar.",
  },
  confirmReport: {
    question: "¿Quieres crear un informe aquí?",
    yes: "Sí",
    no: "No"
  },
  locationPrompt: "Haz clic en el punto deseado para informar un problema",
  reportHere: "Reportar aquí",
  deleteAccount: {
    title: "Eliminar Cuenta",
    warning: "¡Esta acción es irreversible!",
    description: "Todos tus datos se eliminarán permanentemente, incluyendo:",
    items: {
      reports: "Todos tus informes",
      photos: "Todas las fotos subidas",
      accountData: "La información de tu cuenta"
    },
    confirmLabel: "Escribe DELETE para confirmar",
    confirmPlaceholder: "DELETE",
    cancel: "Cancelar",
    deleteButton: "Eliminar Mi Cuenta",
    deleting: "Eliminando...",
    success: "Cuenta eliminada exitosamente",
    error: "Error al eliminar la cuenta"
  },
  gamification: {
    totalReports: "Reportes totales",
    congratulations: "¡Felicitaciones!",
    pointsEarned: "Puntos ganados",
    totalPoints: "Puntos totales",
    currentLevel: "Nivel actual",
    levelUp: "¡Subiste de Nivel!",
    nextLevel: "Próximo nivel",
    progress: "Progreso",
    thankYou: "¡Gracias por hacer de la ciudad un lugar mejor!",
    keepGoing: "¡Sigue reportando para alcanzar el siguiente nivel!",
    continue: "Continuar",
    levels: {
      beginner: "Principiante",
      active_citizen: "Ciudadano Activo",
      urban_observer: "Observador Urbano",
      city_guardian: "Guardián de la Ciudad",
      civic_champion: "Campeón Cívico",
      urban_hero: "Héroe Urbano"
    },
    messages: {
      beginner: "¡Bienvenido a la comunidad!",
      active_citizen: "¡Estás haciendo la diferencia!",
      urban_observer: "¡Tus ojos hacen la ciudad mejor!",
      city_guardian: "¡Eres un verdadero guardián!",
      civic_champion: "¡Campeón del deber cívico!",
      urban_hero: "¡Eres un héroe urbano!"
    }
  },
  onboarding: {
    step1: {
      title: "¡Bienvenido al Mapa!",
      description: "Aquí puedes ver todos los reportes de tu comunidad. ¡Aprendamos cómo usarlo!"
    },
    step2: {
      title: "Crea un Reporte",
      description: "Busca una ubicación o haz clic en el mapa para crear un nuevo reporte sobre un problema en tu área."
    },
    step3: {
      title: "Tipos de Reporte",
      description: "Los diferentes colores representan diferentes tipos de problemas. ¡Haz clic en los marcadores para ver detalles y dar upvote a los reportes que te importan!"
    },
    step4: {
      title: "Tu Perfil y Gamificación",
      description: "¡Gana puntos creando reportes y ayudando a tu comunidad! Rastrea tu nivel y progreso aquí."
    },
    step5: {
      title: "¡Estás Listo!",
      description: "Comienza a mejorar tu comunidad reportando problemas e interactuando con otros reportes. ¡Cada contribución cuenta!"
    },
    previous: "Anterior",
    next: "Siguiente"
  },
    accountSettings: {
    title: "Configuración de cuenta",
    openSettings: "Configuración de cuenta",
    changeEmail: "Cambiar email",
    newEmailLabel: "Nueva dirección de email",
    newEmailPlaceholder: "nuevo@email.com",
    changePassword: "Cambiar contraseña",
    newPasswordLabel: "Nueva contraseña",
    newPasswordPlaceholder: "Al menos 6 caracteres",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
    passwordSuccess: "Contraseña actualizada correctamente",
    changeUsername: "Cambiar nombre de usuario",
    newUsernameLabel: "Nuevo nombre de usuario",
    newUsernamePlaceholder: "Tu nombre de usuario",
    usernameTooShort: "El nombre de usuario debe tener al menos 2 caracteres",
    usernameSuccess: "Nombre de usuario actualizado correctamente",
    deleteAccountTitle: "Eliminar cuenta",
    deleteAccountDescription: "Elimina permanentemente tu cuenta y todos los datos relacionados. Esta acción no se puede deshacer.",
    deleteAccountButton: "Eliminar cuenta",
    save: "Guardar",
    saving: "Guardando...",
    submit: "Enviar email de confirmación",
    submitting: "Enviando...",
    invalidEmail: "Email no válido",
    error: "Error",
    updateFailed: "No se pudo actualizar",
    successTitle: "Email de verificación enviado",
    successDescription: "Enviamos un email de confirmación a {email}. Revisa tu bandeja de entrada para confirmar el cambio.",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
  },
  push: {
    title: "Notificaciones push",
    subtitle: "Gestiona las notificaciones que recibes en tu dispositivo",
    enable: "Activar notificaciones push",
    denied: "Permiso denegado. Activa las notificaciones en los ajustes del dispositivo.",
    registered: "Dispositivo registrado",
    requestPermission: "Solicita permiso para recibir notificaciones",
    resolved: "Reporte resuelto",
    resolvedDesc: "Cuando se resuelve uno de tus reportes",
    upvotes: "Votos recibidos",
    upvotesDesc: "Cuando alguien vota tus reportes",
    achievements: "Logros desbloqueados",
    achievementsDesc: "Cuando desbloqueas un nuevo logro",
    newReports: "Nuevos reportes",
    newReportsDesc: "Cuando se crean nuevos reportes",
    updated: "Preferencias actualizadas",
    updateError: "No se pudieron actualizar las preferencias",
    mobileOnly: "Las notificaciones push se envían en la aplicación móvil",
  },
  referral: {
    inviteTitle: "¡Invita amigos y gana puntos!",
    inviteSubtitle: "Crea tu código de invitación y gana 50 puntos por cada amigo que se registre.",
    createCode: "Crear código de invitación",
    yourCode: "Tu código de invitación",
    copy: "Copiar",
    codeCopied: "¡Código copiado al portapapeles!",
    linkCopied: "¡Enlace de invitación copiado!",
    directLink: "Enlace directo",
    stats: "Estadísticas de invitaciones",
    completed: "Completadas",
    pending: "Pendientes",
    total: "Total",
    ambassadorProgress: "Progreso de Embajador",
    ambassadorUnlocked: "¡Has desbloqueado la insignia de Embajador!",
    shareText: "¡Únete a ShapeIt y ayuda a mejorar tu ciudad! Usa mi código {code} para recibir 50 puntos extra 🎁",
    shareTitle: "Invitación ShapeIt",
  },
  misc: {
    mapLoadFailed: "No se pudo cargar el mapa",
    mapKeyError: "No se pudo cargar la clave API de Google Maps",
    mapKeyMissing: "Clave API de Google Maps no configurada",
    mapsLoadError: "No se pudo cargar Google Maps",
    onlyImages: "Solo se permiten imágenes JPEG, PNG y WebP",
    imageTooLarge: "La imagen debe pesar menos de 5MB",
    photoFailed: "No se pudo tomar la foto",
    current: "Actual",
    progress: "Progreso",
  },
  common: {
    share: "Compartir",
    shareTitle: "Compartir este reporte",
    copyLink: "Copiar enlace",
    linkCopied: "¡Enlace copiado al portapapeles!",
    copyFailed: "No se pudo copiar el enlace",
    loading: "Cargando...",
    close: "Cerrar",
    delete: "Eliminar",
    cancel: "Cancelar",
    retry: "Reintentar",
    login: "Iniciar sesión",
    register: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    username: "Nombre de usuario",
    anonymous: "Anónimo",
    notYourReport: "No es tu reporte",
    loginToDelete: "Inicia sesión para eliminar",
    upvotes: "Votos",
    reportedBy: "Reportado por",
    trending: "Tendencia",
    trendingReports: "Reportes en tendencia",
    noTrending: "Aún no hay reportes en tendencia",
    yourReports: "Tus reportes",
    noReportsYet: "Todavía no has creado reportes",
    loadingAddress: "Cargando dirección…",
    myLocation: "Mi ubicación",
    yourLocation: "Tu ubicación",
    mapView: "Vista de mapa",
    satelliteView: "Vista satélite",
    changePhoto: "Cambiar foto",
    uploadingPhoto: "Subiendo...",
    photoUpdated: "Foto de perfil actualizada",
    photoUploadError: "No se pudo subir la foto",
    removePhoto: "Eliminar foto",
    inviteFriends: "Invitar amigos",
    achievements: "Logros",
    noAchievements: "Aún no has desbloqueado logros",
    statusHistory: "Historial de estado",
    seeTranslation: "Ver traducción",
    seeOriginal: "Ver original",
    translating: "Traduciendo...",
    translationFailed: "Traducción no disponible",
    translatedAutomatically: "Traducido automáticamente",
    deleteConfirm: "¿Quieres eliminar este reporte?",
    loginToDeleteReports: "Inicia sesión para eliminar reportes",
    onlyOwnReports: "Solo puedes eliminar tus propios reportes",
  },
  auth: {
    backToMap: "Volver al mapa",
    subtitle: "Inicia sesión o crea una cuenta para reportar problemas en tu comunidad",
    login: "Iniciar sesión",
    register: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    username: "Nombre de usuario",
    orContinueWith: "O continúa con",
    signInGoogle: "Iniciar sesión con Google",
    signUpGoogle: "Registrarse con Google",
    signingIn: "Iniciando sesión...",
    signIn: "Iniciar sesión",
    referralLabel: "Código de invitación (opcional) 🎁",
    referralPlaceholder: "Introduce un código de invitación",
    referralBonus: "¡Recibirás 50 puntos extra con este código! 🎁",
    creatingAccount: "Creando cuenta...",
    createAccount: "Crear cuenta",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
  },
  analytics: {
    otherCategory: "Otro",
    pageTitle: "Panel de Analytics",
    pageSubtitle: "Estadísticas públicas y transparencia sobre los reportes de la comunidad",
    backToMap: "Volver al mapa",
    noData: "No hay datos disponibles",
    communityTitle: "Analytics de la comunidad",
    communitySubtitle: "Estadísticas en tiempo real de los reportes ciudadanos",
    municipalityScopedSubtitle: "Estadísticas en tiempo real de los reportes de tu municipio",
    totalReports: "Reportes totales",
    inProgress: "En curso",
    resolved: "Resueltos",
    avgTime: "Tiempo medio",
    categoryTitle: "Distribución por categoría",
    categoryDesc: "Tipos de reportes recibidos",
    trendTitle: "Tendencia últimos 7 días",
    trendDesc: "Número de reportes diarios",
    topAreasTitle: "Zonas más reportadas",
    topAreasDesc: "Las áreas con más reportes activos",
    adminTitle: "Analytics avanzados (Admin)",
    adminSubtitle: "Métricas detalladas visibles solo para administradores",
    dau: "Usuarios activos diarios",
    wau: "Usuarios activos semanales",
    mau: "Usuarios activos mensuales",
    avgSession: "Duración media de sesión",
    minutesShort: "min",
    mapInteractions: "Interacciones con el mapa",
    perSession: "Media por sesión",
    reportsPerUser: "Reportes por usuario",
    average: "Media",
    completionRate: "Tasa de finalización",
    loginToReport: "Inicio de sesión → Reporte",
    funnelTitle: "Embudo de conversión",
    funnelDesc: "Análisis del recorrido del usuario (últimos 7 días)",
    users: "Usuarios",
    conversionPct: "% Conversión",
    devicesTitle: "Distribución de dispositivos",
    devicesDesc: "Análisis de los dispositivos utilizados",
  },
};
